/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../../../core/utils"
import { getCivilStatusLabel } from "../../ClientPage/service/ClientPageServices"
import Bloc from "./Bloc"
import Field from "./Field"
import React from "react"
import { Col } from "react-bootstrap"

export default function IdentityBloc({ configuration, values, tunnelData }) {
  let { identity, leaderIdentity } = configuration

  identity = identity ? identity : leaderIdentity

  return (
    <Bloc hide={!identity} name={leaderIdentity ? "My Leader identity" : "My identity"}>
      {values.identity.isSmallBusiness && (
        <Col className="align-self-center p-0">
          <p className="text-dark">{loc("SmallBusiness")}</p>
        </Col>
      )}
      <Field
        hide={!identity?.includes("title")}
        name={"Title"}
        value={getCivilStatusLabel(tunnelData, values.identity.title)}
      />
      <Field
        hide={!identity?.includes("name") && !identity?.includes("name") && !identity?.includes("leaderName")}
        name={identity?.includes("name") ? "Last name" : "leader name"}
        value={values.identity.name}
      />
      <Field
        hide={!identity?.includes("secondSurname")}
        name={"Last second name"}
        value={values.identity.secondSurname}
      />
      <Field
        hide={!identity?.includes("firstName") && !identity?.includes("leaderFirstName")}
        name={identity?.includes("name") ? "First name" : "leader first name"}
        value={values.identity.firstName}
      />
      <Field hide={!identity?.includes("taxNumber")} name={"Tax number"} value={values.identity.taxNumber} />
      <Field
        hide={!identity?.includes("identificationExpirationDate")}
        name={"Identification expiration date"}
        value={values.identity.identificationExpirationDate}
      />
      <Field
        hide={!identity?.includes("typeOfResidence")}
        name={"Type of residence"}
        value={values.identity.typeOfResidence?.label}
      />
      <Field
        hide={!identity?.includes("citizenShipCountry")}
        name={"Citizenship"}
        value={values.identity.citizenShipCountry?.label}
      />
      <Field
        hide={!identity?.includes("identityDocumentType")}
        name={"Identity document type"}
        value={values.identity.identityDocumentType?.label}
      />
      <Field hide={!identity?.includes("birthDate")} name={"Birthdate"} value={values.identity.birthDate} />
      <Field
        hide={!identity?.includes("birthCountry")}
        name={"Country of birth"}
        value={values.identity.birthCountry?.label}
      />
      <Field
        hide={!identity?.includes("birthDepartment")}
        name={"Department of birth"}
        value={values.identity.birthDepartment?.label}
      />
      <Field
        hide={!identity?.includes("birthCity")}
        name={"City of birth"}
        value={values.identity.birthCity?.label ? values.identity.birthCity?.label : values.identity.birthCity}
      />
    </Bloc>
  )
}
